import React from 'react';

export const isAvatarImage = (avatar?: string): boolean => {
  if (!avatar) return false;
  return avatar.startsWith('/') || avatar.startsWith('data:') || avatar.includes('.svg') || avatar.includes('media');
};

export const renderAvatar = (avatar?: string, size: string = '1.5rem'): React.ReactNode => {
  if (isAvatarImage(avatar)) {
    return <img src={avatar} alt="" style={{ width: size, height: size, objectFit: 'contain' }} />;
  }
  return <span style={{ fontSize: size }}>{avatar || '👤'}</span>;
};
